import { NumericQuestion } from "./numeric-question";
import type { QuestionTypeRendererProps } from "./shared";

type ScaleQuestionProps = QuestionTypeRendererProps<"scale">;

export default function ScaleQuestionType(props: ScaleQuestionProps) {
  return <NumericQuestion {...props} kind="scale" />;
}
